<template>
    <el-dialog title="胚布选择" :visible.sync="DialogVisible" width="40%" @close="XXX" :close-on-click-modal="false">

        <el-row :gutter="10">
            <el-col span="">
                <div class="col-body">
                    <el-table :data="responseData" @selection-change="handleSelectionChange" 
                        :header-cell-style="{'text-align':'center'}" :cell-style="{'padding':'0px'}" border stripe
                        id="XXXX" ref="multipleTable" @row-click="handleRowClick">

                        <el-table-column type="selection" width="55" align="center">
                        </el-table-column>

                        <el-table-column prop="number" label="胚布编号" align="center">
                        </el-table-column>

                        <el-table-column prop="name" label="胚布名称" align="center">
                        </el-table-column>

                    </el-table>
                </div>

                <el-pagination style="text-align: center" background layout="prev, pager, next"
                    @current-change="handleCurrentChange" :page-size="pageInfo.size" :current-page="pageInfo.page"
                    :page-count="totalPages">
                </el-pagination>
            </el-col>
        </el-row>


        <div slot="footer">
            <el-button type="" @click="cancel()">取消</el-button>
            <el-button type="primary" @click="onSubmit()">确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import * as api from '@/api/factory/machine/list/add'
    export default {
        data() {
            var lengthruler = (rules, value, cb) => {
                const ruler = /(^[1-9]([0-9]*)$|^[1-9]$)/
                if (ruler.test(value)) {
                    return cb()
                }
                cb(new Error('请输入大于0的正整数'))
            }
            return {
                DialogVisible: false,
                responseData: [
                    // 调试用假数据--正式版注释掉
                    // {
                    //     number: '测试1',
                    //     name: '测试1',
                    // },
                ],

                selectYuanLiaoId: 0, //当前 选择原料的 id

                //已选胚布
                selectedPeiBu: {
                    materialId: 0, //物料ID
                    name: '', //物料名称
                    number: '', //物料编号
                    unit: '', //单位: 米/千克

                    lineNo: 0, //入库单,出库单 操作，记录点击“物料信息” 列表的哪一行。
                },

                //分页相关--sta
                pageInfo: {
                    page: 1,
                    size: 10,
                    kind: 'PB', //胚布 = PB, 原料 = YL。
                },
                totalPages: 0,
                //分页相关--end

                recordLineNo: 0, //入库单,出库单 操作，记录点击“物料信息” 列表的哪一行。
				multipleSelection: [],
            }
        },
        methods: {
			handleSelectionChange(val) {
				this.multipleSelection = val
			},
            // 外部调用，显示添加机台弹框
            show(inputData) {
                if (inputData != undefined) {
                    // console.log("inputData=", inputData)
                    this.recordLineNo = typeof(inputData)=='object'?inputData.lineNo:inputData
                }

                this.DialogVisible = true
                //显示对话框 时候 要加载数据
                this.getWuLiaoList(1, 'PB')
            },

            // 外部调用，取 选中的胚布信息。
            getPeiBuInfo() {
                return this.multipleSelection
            },

            // 监听回车按钮
            keyCodeListen() {
                // const code = event.keyCode ? event.keyCode : event.which ? event.which : event.charCode
                const code = event.keyCode
                if (code === 13) this.onSubmit()
            },
            // 点击 确定 按钮
            onSubmit() {
                if (this.selectYuanLiaoId === 0) {
                    this.$Message.closeAll()
                    this.$Message.success('还未选择 或者 胚布表 为空。')
                } else {
                    this.selectedPeiBu.materialId = this.responseData[this.selectYuanLiaoId - 1].id //物料ID
                    this.selectedPeiBu.name = this.responseData[this.selectYuanLiaoId - 1].name //物料名称
                    this.selectedPeiBu.number = this.responseData[this.selectYuanLiaoId - 1].number //物料编号
                    
                    this.selectedPeiBu.unit = this.responseData[this.selectYuanLiaoId - 1].unit //单位

                    //入库单,出库单 操作，记录点击“物料信息” 列表的哪一行。
                    this.selectedPeiBu.lineNo = this.recordLineNo

                    this.$emit('update') //触发 回调的 update函数???
                    this.DialogVisible = false
                }
            },
            // 点击取消按钮触发
            cancel() {
                this.DialogVisible = false
            },
            mounted() {
                document.addEventListener('keyup', this.keyCodeListen)
            },
            destroyed() {
                document.removeEventListener('keyup', this.keyCodeListen)
            },


            // 获取 胚布+原料 分页列表
            getWuLiaoList(val, kind) {
                if (kind === undefined) { //选中 超过1 的页数。
                    // this.pageInfo.kind = XXX     不需要改变kind.
                } else { //选中 第1页。
                    this.pageInfo.kind = kind
                }

                //---------------------
                this.pageInfo.page = val

                this.$requestBase({
                    url: 'v1/material/list',
                    method: 'get',
                    params: this.pageInfo
                }).then(res => {
                    this.responseData = this.formatResponse(res.data.list)

                    this.totalPages = res.data.pages
                })
            },
            // 格式化 胚布+原料 列表
            formatResponse(response) {
                response.forEach((item, index) => {
                    item.local_id = index + 1
                    item.createTime = this.utils.timestampToTime(item.createTime, 2)
                })
                return response
            },

            //"选择原料" 单击一行
            handleRowClick(row, event, column) {
                // console.log('row=', row)
                // console.log('event=', event)
                // console.log('column=', column)
                // console.log('row.local_id=', row.local_id)
                this.selectYuanLiaoId = row.local_id
				this.$refs.multipleTable.toggleRowSelection(row)
            },


            // 分页切换
            handleCurrentChange(newNum) {
                this.getWuLiaoList(newNum)
            },

        }
    }
</script>

<style lang="scss" scoped>
    .col-title {
        padding: 5px 0px;
        font-weight: bold;
    }

    .col-body {
        height: 400px;
        border: 1px solid #ccc;
        padding: 0px;
    }
</style>
